import { render } from "./TrueLayerDashboard.vue?vue&type=template&id=12518062&scoped=true"
import script from "./TrueLayerDashboard.vue?vue&type=script&lang=js"
export * from "./TrueLayerDashboard.vue?vue&type=script&lang=js"

import "./TrueLayerDashboard.vue?vue&type=style&index=0&id=12518062&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12518062"]])

export default __exports__